import { LANGUAGE_CHANGED } from '../actions/languageActions';
var languageMiddleware = function languageMiddleware(store) {
  return function (next) {
    return function (action) {
      if (action.type === LANGUAGE_CHANGED) {
        var lang = action.payload.lang;
        if (localStorage.getItem('language') !== lang) {
          localStorage.setItem('language', lang);
        }
      }
      return next(action);
    };
  };
};
export default languageMiddleware;